// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2742":"ef0b6c78","3629":"39f5e97a","8143":"39f5e97a","8628":"0e12e164","8709":"ef0b6c78"}[chunkId] + ".chunk.css";
};